<template>
  <div></div>
</template>

<script>
export default {
  created() {
    this.$authService.prototype.signOut();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/shared/Logout.vue